/**
 * Default options for all Shepherd.Tour instances.
 */
const tourDefaults = {
  useModalOverlay: true,
  keyboardNavigation: true,
  exitOnEsc: true,
  defaultStepOptions: {
    scrollTo: { behavior: 'smooth', block: 'center' },
    cancelIcon: { enabled: true },
    classes: 'lawis-tour-step',
    modalOverlayOpeningRadius: 8,
    modalOverlayOpeningPadding: 6,
    popperOptions: {
      modifiers: [
        { name: 'offset', options: { offset: [0, 12] } },
        { name: 'preventOverflow', options: { padding: 16 } },
      ],
    },
  },
};

export default tourDefaults;
